/*
 * Reemplazo de angular-webstorage-service (ultima publicacion: diciembre de 2017).
 *
 * Replica el token de inyeccion y la interfaz que usaba el proyecto, de modo que en los
 * consumidores solo cambia la linea del import. El uso real en el proyecto es set, get
 * y remove sobre sessionStorage.
 */
import { InjectionToken } from '@angular/core';

export interface StorageService {
	get<T = unknown>(key: string): T | null;
	set(key: string, value: unknown): void;
	remove(key: string): void;
}

/** Implementacion sobre el Storage del navegador, tolerante a modo privado. */
class WebStorage implements StorageService {
	constructor(private readonly backend: Storage) {}

	get<T = unknown>(key: string): T | null {
		try {
			const raw = this.backend.getItem(key);
			return raw === null ? null : (JSON.parse(raw) as T);
		} catch {
			return null;
		}
	}

	set(key: string, value: unknown): void {
		try {
			this.backend.setItem(key, JSON.stringify(value));
		} catch {
			// Almacenamiento bloqueado o lleno: se ignora, igual que la libreria anterior.
		}
	}

	remove(key: string): void {
		try {
			this.backend.removeItem(key);
		} catch {
			// idem
		}
	}
}

export const SESSION_STORAGE = new InjectionToken<StorageService>('SESSION_STORAGE', {
	providedIn: 'root',
	factory: () => new WebStorage(sessionStorage),
});

export const LOCAL_STORAGE = new InjectionToken<StorageService>('LOCAL_STORAGE', {
	providedIn: 'root',
	factory: () => new WebStorage(localStorage),
});
